// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// function AdminLoginPage() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');

//     try {
//       const response = await fetch('http://localhost:5000/admin_login');
//       const data = await response.json();

//       const admin = data.find(
//         (user) => user.admin_email === email && user.password === password
//       );

//       if (admin) {
//         navigate('/AdminPagelionsIndia');
//       } else {
//         setError('Invalid email or password');
//       }
//     } catch (err) {
//       setError('Server error. Please try again later.');
//     }
//   };

//   const styles = {
//     body: {
//       margin: 0,
//       fontFamily: "'Segoe UI', sans-serif",
//       background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//       height: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//     },
//     card: {
//       background: 'white',
//       padding: '2rem 3rem',
//       borderRadius: '10px',
//       boxShadow: '0 5px 25px rgba(0, 0, 0, 0.3)',
//       width: '100%',
//       maxWidth: '400px',
//       textAlign: 'center',
//     },
//     title: {
//       marginBottom: '1.5rem',
//       color: '#2c5364',
//     },
//     input: {
//       width: '100%',
//       padding: '0.8rem',
//       marginBottom: '1rem',
//       border: '1px solid #ccc',
//       borderRadius: '5px',
//       fontSize: '1rem',
//     },
//     button: {
//       background: '#2c5364',
//       color: 'white',
//       padding: '0.8rem',
//       border: 'none',
//       width: '100%',
//       borderRadius: '5px',
//       fontSize: '1rem',
//       cursor: 'pointer',
//     },
//     buttonHover: {
//       background: '#203a43',
//     },
//     error: {
//       color: 'red',
//       marginBottom: '1rem',
//     },
//   };

//   return (
//     <div style={styles.body}>
//       <div style={styles.card}>
//         <h2 style={styles.title}>Admin Login</h2>
//         <form onSubmit={handleLogin}>
//           <input
//             type="email"
//             placeholder="Email"
//             style={styles.input}
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             required
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             style={styles.input}
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             required
//           />
//           {error && <p style={styles.error}>{error}</p>}
//           <button
//             type="submit"
//             style={styles.button}
//             onMouseOver={(e) => (e.target.style.background = '#203a43')}
//             onMouseOut={(e) => (e.target.style.background = '#2c5364')}
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default AdminLoginPage;



// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaEnvelope, FaLock } from 'react-icons/fa';

// function AdminLoginPage() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError('');
//     try {
//       const res = await fetch('http://localhost:5000/admin_login');
//       const data = await res.json();
//       const admin = data.find(user => user.admin_email === email && user.password === password);
//       if (admin) navigate('/AdminPagelionsIndia');
//       else setError('Invalid email or password');
//     } catch {
//       setError('Server error. Try again later');
//     }
//   };

//   const styles = {
//     container: {
//       margin: 0,
//       padding: 0,
//       fontFamily: 'Segoe UI, sans-serif',
//       background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//       height: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//     },
//     card: {
//       background: 'white',
//       padding: '2rem',
//       borderRadius: '10px',
//       boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
//       maxWidth: '400px',
//       width: '100%',
//       textAlign: 'center',
//     },
//     logo: {
//       width: '80px',
//       marginBottom: '1rem',
//     },
//     title: {
//       color: '#2c5364',
//       marginBottom: '1.5rem',
//       fontSize: '1.5rem',
//       fontWeight: '600',
//     },
//     inputContainer: {
//       position: 'relative',
//       marginBottom: '1rem',
//     },
//     icon: {
//       position: 'absolute',
//       top: '50%',
//       left: '12px',
//       transform: 'translateY(-50%)',
//       color: '#999',
//     },
//     input: {
//       width: '100%',
//       padding: '12px 12px 12px 40px',
//       border: '1px solid #ccc',
//       borderRadius: '5px',
//       fontSize: '1rem',
//     },
//     button: {
//       background: '#2c5364',
//       color: 'white',
//       padding: '12px',
//       border: 'none',
//       width: '100%',
//       borderRadius: '5px',
//       fontSize: '1rem',
//       cursor: 'pointer',
//       transition: 'background 0.3s',
//     },
//     buttonHover: {
//       background: '#203a43',
//     },
//     error: {
//       color: 'red',
//       marginBottom: '1rem',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.card}>
//         <img
//           src="https://via.placeholder.com/80?text=LI"
//           alt="Lions India Logo"
//           style={styles.logo}
//         />
//         <h2 style={styles.title}>Lions India Admin</h2>
//         <form onSubmit={handleLogin}>
//           <div style={styles.inputContainer}>
//             <FaEnvelope style={styles.icon} />
//             <input
//               type="email"
//               placeholder="Email"
//               style={styles.input}
//               value={email}
//               onChange={e => setEmail(e.target.value)}
//               required
//             />
//           </div>
//           <div style={styles.inputContainer}>
//             <FaLock style={styles.icon} />
//             <input
//               type="password"
//               placeholder="Password"
//               style={styles.input}
//               value={password}
//               onChange={e => setPassword(e.target.value)}
//               required
//             />
//           </div>
//           {error && <p style={styles.error}>{error}</p>}
//           <button
//             type="submit"
//             style={styles.button}
//             onMouseOver={e => (e.target.style.background = styles.buttonHover.background)}
//             onMouseOut={e => (e.target.style.background = styles.button.background)}
//           >
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// export default AdminLoginPage;



import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import logo from '../images/logo.png'
function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('https://lcoiapi.emedha.in/appi/admin_login');
      const data = await res.json();
      const admin = data.find(
        (user) => user.admin_email === email && user.password === password
      );
      if (admin) {
        localStorage.setItem('isAuthenticatedAdmin', 'true'); // <-- Set auth flag
        navigate('/AdminPagelionsIndia');
      } else {
        setError('Invalid email or password');
      }
    } catch {
      setError('Server error. Try again later');
    }
  };

  const styles = {
    container: {
      margin: 0,
      padding: 0,
      fontFamily: 'Segoe UI, sans-serif',
      background: 'linear-gradient(135deg, #1c509c, #6486bb, #cdb22b, #ecfbfb, #bbddf3)',
      backgroundSize: '400% 400%',
      animation: 'gradientMove 15s ease infinite',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    card: {
      background: 'white',
      padding: '2rem',
      borderRadius: '15px',
      boxShadow: '0 15px 40px rgba(0,0,0,0.3)',
      maxWidth: '400px',
      width: '90%',
      textAlign: 'center',
      transform: isHovered ? 'scale(1.03)' : 'scale(1)',
      transition: 'transform 0.3s ease',
    },
    logo: {
      width: '70px',
      marginBottom: '1rem',
    },
    title: {
      color: '#1c509c',
      marginBottom: '1.2rem',
      fontSize: '1.6rem',
      fontWeight: 600,
    },
    inputContainer: {
      position: 'relative',
      marginBottom: '1.2rem',
    },
    icon: {
      position: 'absolute',
      top: '50%',
      left: '12px',
      transform: 'translateY(-50%)',
      color: '#888',
    },
    input: {
      width: '100%',
      padding: '12px 12px 12px 40px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      fontSize: '1rem',
      transition: 'box-shadow 0.3s',
    },
    inputFocus: {
      boxShadow: '0 0 0 2px #1c509c33',
    },
    button: {
      background: isHovered ? '#1c509c' : '#6486bb',
      color: 'white',
      padding: '12px',
      border: 'none',
      width: '100%',
      borderRadius: '8px',
      fontSize: '1rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'background 0.4s ease',
    },
    error: {
      color: 'red',
      fontSize: '0.9rem',
      marginBottom: '1rem',
    },
    // Keyframes for animated background
    '@keyframes gradientMove': {
      '0%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' },
      '100%': { backgroundPosition: '0% 50%' },
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes gradientMove {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `}
      </style>
      <div
        style={styles.card}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={logo}
          alt="Logo"
          style={styles.logo}
        />
        <h2 style={styles.title}>🔐 Lions India Admin</h2>
        <form onSubmit={handleLogin}>
          <div style={styles.inputContainer}>
            <FaEnvelope style={styles.icon} />
            <input
              type="email"
              placeholder="Email"
              style={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={styles.inputContainer}>
            <FaLock style={styles.icon} />
            <input
              type="password"
              placeholder="Password"
              style={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button type="submit" style={styles.button}>
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginPage;
